const adminAdRouter = [
  {
    path: '/admin/g',
    name: 'AdminAdIndex',
    component: () => import('@/views/admin/ad/index')
  },
  {
    path: '/admin/g/create',
    name: 'AdminAdCreate',
    component: () => import('@/views/admin/ad/create')
  },
  {
    path: '/admin/g/edit',
    name: 'AdminAdEdit',
    component: () => import('@/views/admin/ad/edit')
  }
]

export default adminAdRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/ad.js